import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {

  constructor(
    public apiService: ApiService
  ) { }
  private rejectProd = new BehaviorSubject({});
  getRejectProduct = this.rejectProd.asObservable();

  private rejectMat = new BehaviorSubject({});
  getRejectMaterial = this.rejectMat.asObservable();

  changeEditRejectProd(data: any) {
    this.rejectProd.next(data)
  }

  changeEditRejectMat(data: any){
    this.rejectMat.next(data)
  }

  createReleaseMaterialProduct(body : any): Observable<any> {
    return this.apiService.post('rmp/createReleaseMaterialProducts', body)
  }

  createReceiveProduct(body : any): Observable<any> {
    return this.apiService.post('rp/createReceiveProduct', body)
  }
  editReceiveProduct(body : any): Observable<any> {
    return this.apiService.post('rp/editReceiveProduct', body)
  }
  //reject material
getAllRejectMaterials(body : any): Observable<any> {
  return this.apiService.post('rejectMatProd/getAllRejectedList', body)
}
addRejectMaterial(body : any): Observable<any> {
  return this.apiService.post('rejectMatProd/create_Rejected_Mat', body)
}
editRejectMaterial_product(body : any): Observable<any> {
  return this.apiService.post('rejectMatProd/update_Rejected_Mat_Prod', body)
}
//reject product
addRejectProduct(body : any): Observable<any> {
  return this.apiService.post('rejectMatProd/create_Rejected_Product', body)
}
// editRejectProduct(body : any): Observable<any> {
//   return this.apiService.post('rjp/editRejectProduct', body)
// }

getMlos(body : any): Observable<any> {
  return this.apiService.post('mlo/getMLCsbyFormulaId', body)
}
getRecLots(body : any): Observable<any> {
  return this.apiService.post('rm/getReceivedLotsbyMaterialId', body)
}
getRecLotsList(body : any): Observable<any> {
  return this.apiService.post('rm/getReceivedLotsbyMaterialIdList', body)
}
addReturnMaterial(body : any): Observable<any> {
  return this.apiService.post('ReturnMatPro/createReturnMaterialProducts', body)
}
editReturnMaterial(body : any): Observable<any> {
  return this.apiService.post('', body)
}
getRecProductByFormulaId(body : any): Observable<any> {
  return this.apiService.post('rp/getReceiveProductByFormulaId', body)
}
getReceivedQtyByFormulaId(body : any): Observable<any> {
  return this.apiService.post('rp/getReceivedQtyByFormulaId', body)
}
updateSohValue(body : any): Observable<any> {
  return this.apiService.post('formulations/updateSohValueFromWarehouse', body)
}
getMiscellaneousReasons(body:any):Observable<any>{
  console.log(body)
  return this.apiService.get(`MiscellaneousReason/getMiscellaneousReasons/${body.company_id}`)
}
addMiscellaneousReason(body:any):Observable<any>{
  return this.apiService.post('MiscellaneousReason/addMiscellaneousReason',body)
}
}
